import { render, staticRenderFns } from "./ReportStatus.vue?vue&type=template&id=19b82922&scoped=true&"
import script from "./ReportStatus.vue?vue&type=script&lang=js&"
export * from "./ReportStatus.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatus.vue?vue&type=style&index=0&id=19b82922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b82922",
  null
  
)

export default component.exports